// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentId } from './Equipment';
import { operatorId } from './Operator';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const equipmentMaintenanceLogId = (z.number());
export const equipmentMaintenanceLog = z.object({
    id: equipmentMaintenanceLogId,
    equipment_id: equipmentId,
    performed_at: z.date(),
    performed_by: operatorId.nullable(),
    description: z.string(),
    notes: z.string().nullable(),
    file_storage_id: fileStorageId.nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const equipmentMaintenanceLogInitializer = z.object({
    id: equipmentMaintenanceLogId.optional(),
    equipment_id: equipmentId,
    performed_at: z.date(),
    performed_by: operatorId.optional().nullable(),
    description: z.string(),
    notes: z.string().optional().nullable(),
    file_storage_id: fileStorageId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const equipmentMaintenanceLogMutator = z.object({
    id: equipmentMaintenanceLogId.optional(),
    equipment_id: equipmentId.optional(),
    performed_at: z.date().optional(),
    performed_by: operatorId.optional().nullable(),
    description: z.string().optional(),
    notes: z.string().optional().nullable(),
    file_storage_id: fileStorageId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=EquipmentMaintenanceLog.js.map